import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root'
})
export class SubService implements OnDestroy {
  private sub?: Subscription;

  constructor(private logger: LoggerService) {
    this.logger.log(`SubService constructor`);
  }
  ngOnDestroy(): void {
    this.clear();
    this.logger.log(`SubService destroyed`);
  }
  private observe<T>(obs: Observable<T>, onOk: (res: T) => void, onErr: (err: number) => void) {
    this.sub = obs.subscribe({
      next: (res) => {
        this.clear();
        onOk(res);
      },
      error: (err: HttpErrorResponse) => {
        this.clear();
        onErr(err.status);
      }
    });
    this.logger.log(`SubService observing`);
  }

  public clear() {
    if (this.sub) {
      this.sub.unsubscribe();
      this.sub = undefined;
    }
  }
  public loading() {
    return !!this.sub;
  }

  public reset<T>(obs: Observable<T>, onOk: (res: T) => void, onErr: (err: number) => void) {
    this.clear();
    this.observe<T>(obs, onOk, onErr);
  }
}
